import React, { Component } from 'react'

class Cafeteria extends Component {
  render() {
    return (
      <div>
        welcome to cafeteria
      </div>
    )
  }
}
export default Cafeteria